import getScriptInfoForLoadedScripts from './utils/getScriptInfoForLoadedScripts';
import trace from './trace';
import { isOneOf } from 'owa-config';
import isCorsIssue from './utils/isCorsIssue';
import { TraceErrorObject } from 'owa-service/lib/types/TraceErrorObject';

const NetworkErrors = ['SyntaxError:', 'A network error occurred.', 'Failed to fetch'];

export default function onGlobalError(
    message: string,
    filename?: string,
    lineno?: number,
    colno?: number,
    error?: TraceErrorObject
) {
    if (!error) {
        error = new Error();
        error.stack = '[empty onerror]';
    }
    if (message) {
        error.message = message;
    }
    error.filename = filename;
    error.lineno = lineno;
    error.colno = colno;

    // Detect CORS issues specifically so we can decorate them.
    // For now we're just prefixing the string. Later when the analytics tables have been updated
    // we'll mark them specifically so we can track them down if needed.
    if (lineno === 0 && isCorsIssue(error.message)) {
        error.message = 'CORS ISSUE: ' + error.message;
        // wrap this so if we have problems with getting additional info, we don't prevent the error reporting
        try {
            error.diagnosticInfo = error.diagnosticInfo || '';
            error.diagnosticInfo += getScriptInfoForLoadedScripts()
                .filter(s => s.cors === null && s.src != 'INLINE')
                .map(
                    info =>
                        `src:${info.src} parent:${info.parentNode} base:${info.baseUri} attr:${info.attributes}\n`
                );
        } catch (e) {
            trace.error('getScriptInfoForLoadedScripts error', e);
        }
    }

    if (isOneOf(NetworkErrors, error.message)) {
        error.networkError = true;
    }

    const alreadyReported = error?.reported;
    if (!alreadyReported) {
        // this will get picked up by any trace listeners for error that are registered globally
        trace.error(error);
    }
}
